export const ADD_NOTE_REQ="ADD_NOTE_REQ";
export const ADD_NOTE_SUCCESS="ADD_NOTE_SUCCESS";
export const ADD_NOTE_FAIL="ADD_NOTE_FAIL";

export const DELETE_NOTE_REQ="DELETE_NOTE_REQ";
export const DELETE_NOTE_SUCCESS="DELETE_NOTE_SUCCESS";
export const DELETE_NOTE_FAIL="DELETE_NOTE_FAIL";

export const UPDATE_NOTE_REQ="UPDATE_NOTE_REQ";
export const UPDATE_NOTE_SUCCESS="UPDATE_NOTE_SUCCESS";
export const UPDATE_NOTE_FAIL="UPDATE_NOTE_FAIL";

export const GET_NOTE_REQ="GET_NOTE_REQ";
export const GET_NOTE_SUCCESS="GET_NOTE_SUCCESS";
export const GET_NOTE_FAIL="GET_NOTE_FAIL";


export const LOGIN_REQ="LOGIN_REQ";
export const LOGIN_SUCCESS="LOGIN_SUCCESS";
export const LOGIN_FAIL="LOGIN_FAIL";
export const LOGOUT = "LOGOUT";
export const LOAD_PROF = "LOAD_PROF";

export const ADD_NOTE="ADD_NOTE";
export const DELETE_NOTE="DELETE_NOTE";
export const UPDATE_NOTE="UPDATE_NOTE";

